import React, { memo } from 'react';
interface TabNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}
const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange
}) => {
  const tabs = [{
    id: 'overview',
    label: 'Overview'
  }, {
    id: 'forms',
    label: 'Forms'
  }, {
    id: 'letters',
    label: 'Letters'
  }, {
    id: 'memos',
    label: 'Memos'
  }];
  return <div className="border-b border-gray-200" data-id="element-176">
      <nav className="-mb-px flex space-x-8" data-id="element-177">
        {tabs.map(tab => <button key={tab.id} className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === tab.id ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `} onClick={() => onTabChange(tab.id)} data-id="element-178">
            {tab.label}
          </button>)}
      </nav>
    </div>;
};
export default TabNavigation;